
import { defineComponent, reactive, ref } from "vue";
import { Users, Roles, Shop } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { saveAs } from "file-saver";
import moment from "moment";
import { ElMessageBox, ElMessage } from "element-plus";
import type { FormRules } from "element-plus";
import KTModalAccounts from "@/components/modals/forms/AccountModal.vue";
import KTModalRoleMenu from "@/components/modals/forms/RoleTreeModal.vue";
import AccountFilter from "@/components/dropdown/AccountFilter.vue";
import { CookieComponent, MenuComponent } from "@/assets/ts/components";
import { componentSize } from "@/utils/userMenuUtil";

interface DataForm {
  nMaTaiKhoan: string | null,
  cMatKhau: string | null,
  /* nMaCuaHang: number | null, */
  cTenTaiKhoan: string | null,
  cHoTen: string | null,
  cQuyenHeThong: string | null,
  nMaNhomQuyen: number | null,
  nTinhTrang: number | null,
  cEmail: string | null,
  cSoDienThoai: string | null,
  cNguoiTao: string | null,
  dNgayTao: string | null,
  cNguoiCapNhatCuoi: string | null,
  dNgayCapNhatCuoi: string | null,
  dNgayBatDau: string | null,
  dNgayKetThuc: string | null,
}

interface User {
  id: number | null;
  name: string | null;
  password: string | null;
  fullName: string | null;
  salt: string | null;
  email: string | null;
  iconFile: string | null;
  cmndTruocFile: string | null;
  cmndSauFile: string | null;
  cmnd: string | null;
  mobile: string | null;
  nTinhTrang: number | null;
  userTypeId: number | null;
  createBy: string | null;
  createTime: Date;
  lastUpdateBy: string | null;
  lastUpdateTime: Date;
  pw: string | null;
  delFlag: number | null;
  verifiedFlag: number | null;
  provinceCode: string | null;
  districtCode: string | null;
  memberCode: string | null;
  fireBaseDeviceId: string | null;
  totalBalance: string | number | null;
  ez: string | null;
  wardCode: string | null;
  address: string | null;
  bankName: number | null;
  bankAccount: string | null;
  nameAccount: string | null;
  appVersion: string | null;
  facebook: string | null;
  birthDate: Date;
  affiliateUser: string | null;
  appleEmail: string | null;
  stringeeToken: string | null;
  deviceName: string | null;
  systemName: string | null;
  memberVerify: number | null;
  hmacSha256: string | null;
  hmacSha256Agent: string | null;
  hmacSha256Customer: string | null;
  signature: string | null;
}

interface Role {
  createBy: string | null;
  createTime: string | null;
  delFlag: number | null;
  id: number | null;
  lastUpdateBy: string | null;
  lastUpdateTime: string | null;
  name: string | null;
  remark: string | null;
}

interface selectedRole {
  id: number | null;
  name: string | null;
}

interface provinces {
  provinceId: string | null;
  provinceCode: number | null;
  provinceName: number | null;
  company: number | null;
  ticketName: string | null;
  lastUpdateBy: string | null;
  lastUpdateTime: string | null;
}

interface districts {
  provinceName: string | null;
  districtId: number | null;
  districtCode: string | null;
  districtName: string | null;
  provinceId: number | null;
  provinceCode: string | null;
}

export default defineComponent({
  name: "accounts",
  components: {
    KTModalAccounts,
    KTModalRoleMenu,
    AccountFilter,
  },
  setup() {
    const store = ref(useStore());
    const router = ref(useRouter());
    const loading = ref<boolean>(false);
    const openDialog = ref<boolean>(false);
    const tableData = ref({
      content: [] as Array<User>,
      pageNum: 1,
      pageSize: 20,
      totalSize: 200,
    });
    const filters = reactive({
      cTenTaiKhoan: "",
      cHoTen: "",
      cSoDienThoai: "",
      searchrole: -1,
      searchStatus: -1,
      pageNum: 1,
      pageSize: 20,
    });
    const pageRequest = reactive({
      columnFilters: {
        cTenTaiKhoan: { value: "" },
        cHoTen: { value: "" },
        cSoDienThoai: { value: "" },
        cQuyenHeThong: { value: 5 },
        nTinhTrang: { value: 5 },
      },
      pageNum: 1,
      pageSize: 20,
      userName: CookieComponent.get("userName"),
    });
    const dataForm = reactive<DataForm>({
      nMaTaiKhoan: "",
      cMatKhau: "",
      /* nMaCuaHang: null, */
      cTenTaiKhoan: null,
      cHoTen: null,
      cQuyenHeThong: "",
      nMaNhomQuyen: null,
      nTinhTrang: 1,
      cEmail: null,
      cSoDienThoai: null,
      cNguoiTao: "",
      dNgayTao: "",
      cNguoiCapNhatCuoi: "",
      dNgayCapNhatCuoi: "",
      dNgayBatDau: "",
      dNgayKetThuc: "",
    });
    const companyNames = ref<string>("");
    const roleName = ref<string | null>("");

    const defaultValues = reactive<DataForm>({
      nMaTaiKhoan: "",
      cMatKhau: "",
      /* nMaCuaHang: null, */
      cTenTaiKhoan: null,
      cHoTen: null,
      cQuyenHeThong: "",
      nMaNhomQuyen: null,
      nTinhTrang: 1,
      cEmail: null,
      cSoDienThoai: null,
      cNguoiTao: "",
      dNgayTao: "",
      cNguoiCapNhatCuoi: "",
      dNgayCapNhatCuoi: "",
      dNgayBatDau: "",
      dNgayKetThuc: "",
    });
    const selectedRole = ref<selectedRole>({ id: null, name: null });
    const size = ref<string>("");
    const openFilter = ref<boolean>(false);
    /*     const provinces = ref<provinces[]>([]);
        const districts = ref<districts[]>([]); */
    const userGroup = ref<Array<User>>([]);

    const userTypes = ref<Array<object>>([]);
    const userTypesWithOutCTVDBL = ref<Array<object>>([]);
    const roleList = ref<Array<any>>([]);
    const rolesCVCN = ref<Array<object>>([]);
    const provinces2 = ref<Array<object>>([]);
    const district2 = ref<Array<object>>([]);
    const bank = ref<Array<object>>([]);
    const showEdit = ref<boolean>(false);
    const shopList = ref<Array<any>>();
    const operation = ref<boolean>(true);
    return {
      showEdit,
      router,
      openDialog,
      tableData,
      pageRequest,
      filters,
      dataForm,
      defaultValues,
      store,
      loading,
      companyNames,
      roleName,
      size,
      selectedRole,
      userGroup,
      userTypes,
      userTypesWithOutCTVDBL,
      roleList,
      rolesCVCN,
      provinces2,
      district2,
      bank,
      openFilter,
      shopList, operation
    };
  },
  methods: {
    handleOpenFilter() {
      this.openFilter = !this.openFilter
    },
    handleResetFilter() {
      this.filters = reactive({
        cTenTaiKhoan: "",
        cHoTen: "",
        cSoDienThoai: "",
        searchrole: 5,
        searchStatus: 5,
        pageNum: 1,
        pageSize: this.filters.pageSize,
      })
      this.handleFindPage(this.filters)
    },
    handleChangePage(val: number) {
      this.findUser(val, this.pageRequest.pageSize);
    },

    handleChangeSize(val: number) {
      this.findUser(this.pageRequest.pageNum, val);
    },

    async handleOpenAdd() {
      this.operation = false
      for (let prop in this.dataForm) {
        this.dataForm[prop] = null;
      }
      this.defaultValues = Object.assign({}, this.dataForm);
    },

    async handleOpenEdit(val: DataForm) {
      this.operation = true
      for (let prop in val) {
        if (prop in this.dataForm)
          this.dataForm[prop] = val[prop];
      }
      this.defaultValues = Object.assign({}, this.dataForm);
    },
    async handleOpenPassword(val: DataForm) {
      for (let prop in val) {
        if (prop in this.dataForm && prop != "cMatKhau")
          this.dataForm[prop] = val[prop];
      }
    },

    handleDelete(val) {
      ElMessageBox.confirm("Bạn có chắc muốn xóa tài khoản này?")
        .then(() => {
          this.store.dispatch(Users.deleteUser, [{nMaTaiKhoan: val.nMaTaiKhoan}]).then((res) => {
            if (res.code == 200) {
              ElMessage({
                message: `Xóa tài khoản ${val.cTenTaiKhoan} thành công`,
                type: "success",
              });

              this.handleFindPage(this.filters);
            } else {
              ElMessage({ message: "Xóa tài khoản thất bại! " + res.msg, type: "error" });
            }
          }).catch(error => {
            ElMessage({ message: "Xóa tài khoản thất bại!", type: "error" });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleBlock(val) {
      /* let params = { id: val.id }; */
      let question = "Bạn có chắc muốn khóa tài khoản này?";
      if (val.nTinhTrang == 0) {
        question = "Bạn có chắc muốn mở khóa tài khoản này?";
      }
/*       const formData = new FormData();
      formData.append('data', new Blob([JSON.stringify(val)], { type: "application/json" })); */
      ElMessageBox.confirm(question)
        .then(() => {
          this.store.dispatch(Users.blockUser, {nMaTaiKhoan: val.nMaTaiKhoan}).then((res) => {
            if (res.code == 200) {
              if (val.nTinhTrang == 1) {
                ElMessage({
                  message: `Khóa tài khoản ${val.name} thành công`,
                  type: "success",
                });
              } else if (val.nTinhTrang == 0) {
                ElMessage({
                  message: `Mở tài khoản ${val.name} thành công`,
                  type: "success",
                });
              }
              this.handleFindPage(this.filters);
            } else {
              ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
            }
          }).catch(error => {
            if (val.nTinhTrang == 1) {
              ElMessage({
                message: `Khóa tài khoản ${val.name} không thành công`,
                type: "error",
              });
            } else if (val.nTinhTrang == 0) {
              ElMessage({
                message: `Mở tài khoản ${val.name} không thành công`,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async handleOpenInfo(val) {
      for (let prop in val) {
        if (prop in this.dataForm && prop != "cMatKhau")
          this.dataForm[prop] = val[prop];
      }
      /* this.handleFindCompanyName(this.dataForm.compNameArray); */
      this.handleFindRoleName([this.dataForm.nMaNhomQuyen] as Array<number>);
    },

    /*     handleMoveToRole(val) {
          this.selectedRole.id = val.nMaNhomQuyen;
          this.selectedRole.name = val.cTenNhomQuyen;
          (
            this.$refs.ktModalRoleMenuRef as typeof KTModalRoleMenu
          ).handleFindRoleMenu(this.selectedRole);
        }, */

    handleFindCompanyName(val) {
      this.companyNames = val.toString();
    },

    handleFindRoleName(val: Array<number>) {
      this.roleName = this.roleList.filter((role) =>
        val.includes(role.nMaNhomQuyen as number)
      )[0].cTenNhomQuyen as string;
    },

    userDownload() {
      try {
        this.pageRequest.columnFilters = {
          cTenTaiKhoan: { value: this.filters.cTenTaiKhoan },
          cHoTen: { value: this.filters.cHoTen },
          cSoDienThoai: { value: this.filters.cSoDienThoai },
          cQuyenHeThong: { value: this.filters.searchrole },
          nTinhTrang: { value: this.filters.searchStatus },
        };
        this.store
          .dispatch(Users.userDownload, this.pageRequest)
          .then((res) => {
            saveAs(
              new Blob([res]),
              "Danh_sach_tai__khoan_" + moment().format("DD.MM.YYYY") + ".xlsx"
            );
          });
      } catch (ex) {
        console.log(ex);
      }
    },

    handleDate(date: string) {
      return moment(date).format("DD/MM/YYYY");
    },

    handleFindByUserGroup(val) {
      this.filters.searchrole = val
      this.findUser(1, 20)
    },

    findUser(pageNum: number, pageSize: number) {
      this.loading = true;
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;

      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 10;

      this.pageRequest.columnFilters = {
        cTenTaiKhoan: { value: this.filters.cTenTaiKhoan },
        cHoTen: { value: this.filters.cHoTen },
        cSoDienThoai: { value: this.filters.cSoDienThoai },
        cQuyenHeThong: { value: this.filters.searchrole },
        nTinhTrang: { value: this.filters.searchStatus },
      };
      this.store
        .dispatch(Users.findPageUser, this.pageRequest)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },

    findAllRoles() {
      this.store
        .dispatch(Roles.findAllRole)
        .then((res) => {
          if (res.code == 200) {
            this.roleList = res.data;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    handleFindPage(val) {
      this.filters = val;
      this.findUser(1, this.tableData.pageSize);
    },

    handleFindUserGroup() {
      /* this.store.dispatch(Users.findUserGroups).then(res => {
        this.userGroup = res.data
      }) */
      console.log("test")
    },
    handleShowShop() {
      this.store.dispatch(Shop.showShop).then(res => {
        if (res.code == 200) {
          this.shopList = res.data
        }
      })
    }
  },
  mounted() {
    this.size = componentSize();
    onresize = () => {
      this.size = componentSize();
    };
    /* this.findAllRoles(); */
    this.handleFindPage(this.filters);
    /* this.handleFindUserGroup(); */
    this.showEdit = true;
    this.findAllRoles();
    this.handleShowShop();
    MenuComponent.reinitialization();
  },
});
